import { Button } from '@pulse-web-ui/button';
import { media, mixins, styled, typography } from '@pulse-web-ui/theme';

export const StyledButton = styled(Button)`
  ${media.desktop} {
    width: auto;
  }
  width: 100%;
  box-sizing: border-box;
`;

export const PageBackButton = styled(Button)<{
  mitePolicy?: boolean;
}>`
  ${typography.regular16}
  ${mixins.flex({
    inline: true,
    verticalAlignment: 'center',
    horizontalAlignment: 'flex-start',
  })};
  margin-bottom: 20px;
  position: relative;
  z-index: 1;
`;

export const PromoSubmitButton = styled(Button)`
  ${typography.medium18};
  ${media.desktop} {
    width: auto;
  }
  flex-shrink: 0;
  width: 100%;
  line-height: 26px;
  border-width: 2px;
  padding: 13px 30px;
`;
